import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import queryString from 'query-string';
import { DesktopRightSidebar } from 'shared/components/BannerAll';
import { injectIntl, intlShape } from 'react-intl';
import withAdvert from 'shared/hocs/withAdvert';
import { connect } from 'react-redux';
import { toLocalized } from 'shared/helpers/locale';
import { generateSearchQuery, generateSparesSearchUrl } from 'shared/helpers/urls';
import Breadcrumbs from 'desktop/components/Breadcrumbs/Breadcrumbs';
import MakesSidebar from 'desktop/components/MakesSidebar/MakesSidebar';
import SearchInput from 'desktop/components/SearchInput/SearchInput';
import InfoMessages from 'desktop/components/InfoMessages/InfoMessages';
import IrrelevantMessage from 'shared/components/IrrelevantMessage/IrrelevantMessage';

import SparepartItem from '../components/SparepartItem/SparepartItem';
import AnotherSpares from '../components/AnotherSpares/AnotherSpares';
import history from '../../../../history';
import s from './SparepartsSinglePage.css';

class SparepartsSinglePage extends React.Component {
  static propTypes = {
    advertInfo: PropTypes.shape().isRequired,
    locale: PropTypes.string.isRequired,
    similar: PropTypes.arrayOf(PropTypes.shape()),
    countToday: PropTypes.number,
    count: PropTypes.number,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    similar: [],
    count: null,
    countToday: null,
  };

  handleSearchSubmit = query => {
    if (query) {
      const basePath = `/${generateSparesSearchUrl({})}`;
      const searchPath = `${basePath}?${queryString.stringify(generateSearchQuery({ query }))}`;

      history.push(toLocalized(searchPath, this.props.locale));
    }
  };

  render() {
    const { advertInfo, similar, countToday, count, intl } = this.props;
    const { rubric, sparetypes, vehicle_type: transport } = advertInfo;
    const sparetype = sparetypes.length > 0 && sparetypes[0];

    const isAutoType = transport && transport.slug === 'avto';

    const basePath = `/${generateSparesSearchUrl({ transport })}`;
    const rubricPath = isAutoType
      ? `/${generateSparesSearchUrl({ transport, rubric })}`
      : `${basePath}?${queryString.stringify(generateSearchQuery({ rubric }))}`;
    const sparetypePath = isAutoType
      ? `/${generateSparesSearchUrl({
          transport,
          rubric,
          sparetype,
        })}`
      : `${basePath}?${queryString.stringify(
          generateSearchQuery({
            rubric,
            sparetype,
          }),
        )}`;

    const links = [
      {
        title: intl.formatMessage({ id: 'Запчасти' }),
        link: basePath,
      },
      rubric &&
        rubric.title && {
          title: rubric.title,
          link: rubricPath,
        },
      {
        title: sparetype && sparetype.title,
        link: sparetypePath,
      },
    ].filter(i => i && i.title && i.link);
    const deleted = advertInfo.active === -2;
    return (
      <div className={s.page} style={{ paddingTop: '20px' }}>
        <InfoMessages countToday={countToday} />
        <div className={s.container}>
          <div className={s.flexRow}>
            <div className={s.mainCell}>
              {deleted ? <IrrelevantMessage title="Это объявление уже неактуально" /> : null}

              <SearchInput
                placeholder={intl.formatMessage({ id: 'Введите номер или название запчасти' })}
                onSubmit={this.handleSearchSubmit}
              />
              <Breadcrumbs links={links} />
              <SparepartItem views={count} advertInfo={advertInfo} />
              <AnotherSpares
                title={intl.formatMessage({ id: 'Похожие запчасти' })}
                spares={similar}
              />
            </div>
            <DesktopRightSidebar fixedSecondBanner>
              <MakesSidebar />
            </DesktopRightSidebar>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ globals }) => ({
  locale: globals.locale,
});

export default withStyles(s)(
  injectIntl(connect(mapStateToProps)(withAdvert(SparepartsSinglePage))),
);



// WEBPACK FOOTER //
// ./src/desktop/routes/spareparts/spareparts-singlepage/SparepartsSinglePage.js